module.exports = __webpack_public_path__ + "static/media/generated-message-hide.e568030c.png";